const styles = (theme) => ({
  arrowDown: {
    "& path": {
      fill: "white",
    },
  },
});

export default styles;
